
export enum AlertType {
    SUCCESS = 0,
    INFO = 1,
    ERROR = 2,
}

export interface AlertDescription {
    id: string,
    title?: string,
    message: React.ReactNode,
    type: AlertType,
}

export interface AlertProviderProps {
    children?: React.ReactNode,
}

export interface AlertContextType {
    alerts: AlertDescription[]
    show: (message: React.ReactNode, title?: string, type?: AlertType) => void,
    success: (message: React.ReactNode, title?: string) => void,
    info: (message: React.ReactNode, title?: string) => void,
    error: (message: React.ReactNode, title?: string) => void,
}